

<template lang="pug">
    span(v-if="stars")
        i.bi.bi-star-fill(v-for="star in stars" :class="{ 'bi-star': star > rating }" @click="$emit('click', { star })")
</template>

<script>
export default {
    name: 'rating-stars',

    props: {
        rating: {
            required: true,
        },
        all: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        stars() {
            return this.all ? 5 : parseInt(this.rating)
        },
    },
}
</script>
